export const standardTransition = value => {
  return `${value} 0.3s ease-out`;
};
